export interface IMasterDataReasonCodeMapping {
  mappingId: number;
  purchaserId: number;
  purchaserName: string | null;
  purchaserKey: string | null;
  reasonCode: string;
  reasonCodeKey: string;
  deductionTypeId: number;
  deductionTypeName: string | null;
  deductionTypeKey: string | null;
  promoTypeId: number | null;
  promoTypeName: string | null;
  createdAt: string | null;
  createdBy: number | null;
  updatedAt: string | null;
  updatedBy: number | null;
}

export class MasterDataReasonCodeMapping {
  private readonly _mappingId: number;
  private readonly _purchaserId: number;
  private readonly _purchaserName: string | null;
  private readonly _purchaserKey: string | null;
  private readonly _reasonCode: string;
  private readonly _reasonCodeKey: string;
  private readonly _deductionTypeId: number;
  private readonly _deductionTypeName: string | null;
  private readonly _deductionTypeKey: string | null;
  private readonly _promoTypeId: number | null;
  private readonly _promoTypeName: string | null;
  private readonly _createdAt: string | null;
  private readonly _createdBy: number | null;
  private readonly _updatedAt: string | null;
  private readonly _updatedBy: number | null;

  constructor(props: IMasterDataReasonCodeMapping) {
    this._mappingId = props.mappingId;
    this._purchaserId = props.purchaserId;
    this._purchaserName = props.purchaserName;
    this._purchaserKey = props.purchaserKey;
    this._reasonCode = props.reasonCode;
    this._reasonCodeKey = props.reasonCodeKey;
    this._deductionTypeId = props.deductionTypeId;
    this._deductionTypeName = props.deductionTypeName;
    this._deductionTypeKey = props.deductionTypeKey;
    this._promoTypeId = props.promoTypeId;
    this._promoTypeName = props.promoTypeName;
    this._createdAt = props.createdAt;
    this._createdBy = props.createdBy;
    this._updatedAt = props.updatedAt;
    this._updatedBy = props.updatedBy;
  }

  get mappingId(): number {
    return this._mappingId;
  }
  get purchaserId(): number {
    return this._purchaserId;
  }
  get purchaserName(): string | null {
    return this._purchaserName;
  }
  get purchaserKey(): string | null {
    return this._purchaserKey;
  }
  get reasonCode(): string {
    return this._reasonCode;
  }
  get reasonCodeKey(): string {
    return this._reasonCodeKey;
  }
  get deductionTypeId(): number {
    return this._deductionTypeId;
  }
  get deductionTypeName(): string | null {
    return this._deductionTypeName;
  }
  get deductionTypeKey(): string | null {
    return this._deductionTypeKey;
  }
  get promoTypeId(): number | null {
    return this._promoTypeId;
  }
  get promoTypeName(): string | null {
    return this._promoTypeName;
  }
  get createdAt(): string | null {
    return this._createdAt;
  }
  get createdBy(): number | null {
    return this._createdBy;
  }
  get updatedAt(): string | null {
    return this._updatedAt;
  }
  get updatedBy(): number | null {
    return this._updatedBy;
  }

  static from(props: IMasterDataReasonCodeMapping): MasterDataReasonCodeMapping {
    return new MasterDataReasonCodeMapping(props);
  }

  static toJSON(
    entity: MasterDataReasonCodeMapping,
  ): IMasterDataReasonCodeMapping {
    return {
      mappingId: entity.mappingId,
      purchaserId: entity.purchaserId,
      purchaserName: entity.purchaserName,
      purchaserKey: entity.purchaserKey,
      reasonCode: entity.reasonCode,
      reasonCodeKey: entity.reasonCodeKey,
      deductionTypeId: entity.deductionTypeId,
      deductionTypeName: entity.deductionTypeName,
      deductionTypeKey: entity.deductionTypeKey,
      promoTypeId: entity.promoTypeId,
      promoTypeName: entity.promoTypeName,
      createdAt: entity.createdAt,
      createdBy: entity.createdBy,
      updatedAt: entity.updatedAt,
      updatedBy: entity.updatedBy,
    };
  }
}

export interface IMasterDataReasonCodeMappingDeleteResult {
  deletedCount: number;
  blockedCount: number;
  blockedIds: number[];
  message: string | null;
}
